import { Controller } from "@hotwired/stimulus"
import { allBundlesStore } from "../../../stores/device_types/all_bundles_store"
import { useStore } from "stimulus-store"
import { sendFailureNotification } from "shared/toast_notifications"
import { getBundles } from "shared/device_types/bundles"

// Connects to data-controller="suppliers--bundles--bundles-supplier"
export default class extends Controller {

    static stores = [
        allBundlesStore
    ]

    static values = {
        autoLoad: Boolean,
        onlyCurrentVersion: Boolean
    }

    connect() {
        useStore(this)

        // If autoLoad is enabled, load bundles immediately
        if (this.autoLoadValue) {
            this.loadBundles()
        }
    }

    /**
     * Load all bundles and populate the allBundlesStore
     */
    async loadBundles() {
        try {
            // Fetch all bundles using the existing service
            const bundles = await getBundles(this.onlyCurrentVersionValue)

            // Update the store with fetched bundles
            this.setAllBundlesStoreValue(bundles)
        } catch (error) {
            console.error('Error loading bundles:', {
                error: error.message,
                timestamp: new Date().toISOString()
            })

            // Show user-friendly error message
            sendFailureNotification('Unable to load bundles. Please try again.')

            // Clear bundles on error
            this.setAllBundlesStoreValue([])
        }
    }

    /**
     * Manually refresh bundles
     */
    refreshBundles() {
        this.loadBundles()
    }

    /**
     * Clear all bundles from the store
     */
    clearBundles() {
        this.setAllBundlesStoreValue([])
    }
}